import Header from '@/components/sections/Header';
import Footer from '@/components/sections/Footer';
import HeroSection from '@/components/sections/HeroSection';
import FeaturesSection from '@/components/sections/FeaturesSection';
import TokenomicsSection from '@/components/sections/TokenomicsSection';
import NFTSection from '@/components/sections/NFTSection';
import RoadmapSection from '@/components/sections/RoadmapSection';
import TeamSection from '@/components/sections/TeamSection';
import FAQSection from '@/components/sections/FAQSection';
import MobileAppBanner from '@/components/sections/MobileAppBanner';
import PartnerSection from '@/components/PartnerSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <TokenomicsSection />
        <NFTSection />
        {/* <RoadmapSection /> */}
        <PartnerSection />
        <TeamSection />
        <FAQSection />
        <MobileAppBanner />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;